<div class="card border-0 me-3">
  <app-platform-icon [platform]="knownPlatform" [size]="4" class="mb-4"></app-platform-icon>
  <p class="card-title product-name pt-3"><strong>{{name}}</strong></p>
  <p class="card-text">Version:&nbsp; {{version}}</p>
  <p class="card-text">{{platformTitle}} License</p>
  <p class="card-text">{{usageType | underscoreToSpace | titlecase }}</p>
  <p class="card-text" *ngIf="includesUpgradeProtection">
    <app-info-circle></app-info-circle> Includes Maintenance (See Below for Details)
  </p>
  <p class="card-text" *ngIf="upgradeProtectionOnly">
    <app-info-circle></app-info-circle> Maintenance Only (See Below for Details)
  </p>
  <!-- For does NOT include Upgrade Maintenance -->
  <p class="card-text no-maintenance" *ngIf="hasNoProtection && anyOfferingsHaveAnyProtection">
    <app-alert-triangle-icon></app-alert-triangle-icon>
    Does NOT Include Maintenance. (See Below for Details)
  </p>
  <p class="card-text product-price mt-2">{{price >= 0.01 ? (price | currency) : 'Free'}}</p>
  <button (click)="addToCart()" class="btn btn-primary py-3 mt-5">Add to Cart</button>
</div>
